module.exports = function getResource(label, vars = []) {
    let resources = {
        selectCurrent: 'Choisissez votre teinte actuelle pour'
    };

    return resources[label];
};
